var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"menu"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"tag":"a","to":"/"}},[_c('i',{staticClass:"icon-nkn-logo"})])],1),_vm._v(" "),_c('div',{staticClass:"nav"},[_c('nkn-header-nav'),_vm._v(" "),_c('nkn-header-lang'),_vm._v(" "),_c('nkn-header-nav-media')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c672743c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/nknHeader.vue
// module id = null
// module chunks = 